export default __webpack_public_path__ + "static/dsHeroImage-ecb1b10628aa66a265a04deb5b667af1.png";